import React from 'react';
import Portal from './portal-view'; // Ensure the Portal component is in the same directory or adjust the import path accordingly
import { IDSSLoader } from '../../building-blocks/DSSFramework';


import './index.scss';
import { Spinner } from './spinner-view';


export const DLSLoader = (props: IDSSLoader) =>
{




    return (
        <div>


            <Portal>
                <div className='modaloverlay' >

                    <Spinner { ...props } />
                </div>
            </Portal>

        </div>
    );
};

